import React from 'react'

import { useModelState } from '../../model-hooks/use-model-state'
import ChartModel from '../../models/chart'

export function withWatchedPanesOnChartModel<P extends { chartModel: ChartModel }>(Component: React.ComponentType<P>) {
  return function WrappedComponent(props: P) {
    // Added also cursor here so it rerenders component on cursor change as it's passed onto panes wrapper style att and didn't want to create new HOC just for that
    const model = useModelState(props.chartModel, { watchProperties: ['panes', 'cursor'] })

    return <Component {...props} model={model} />
  }
}
